
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/api/processors",
      function () {
        return require("private-next-pages/docs/api/processors.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/api/processors"])
      });
    }
  